import { Categories } from "../components";

export const CategoriesPage = () => {
  return (
    <main className="main-wrapper">
      <Categories />
    </main>
  );
};
